import { combineReducers } from 'redux';

import poolReducer from './pool/reducer';

const ipReducer = combineReducers({
	pool: poolReducer,
});

export default ipReducer;
